import { minMaxLenValidator } from 'other';

export const titleRules = minMaxLenValidator('Title', 50, 2);
export const contactRules = [
  { message: 'Please select contact!', required: true }
];
